module.exports = __webpack_public_path__ + "static/media/miranda-color.f963f249.jpg";